{
  "app": {
    "title": "Faturação",
    "close_button": "Fechar",
    "loading": "A carregar..."
  },
  "orders_dashboard": {
    "title": "Encomendas",
    "filter_all": "Tudo",
    "filter_unassigned": "Não atribuído",
    "filter_expiring": "Expirando",
    "filter_undeployed": "Disponível para implementação",
    "filter_canActivate": "Disponível para ativação",
    "search_orders": "Pesquisar encomendas"
  },
  "orders_list": {
    "subscriptionExpiry": "PRAZO DA SUBSCRIÇÃO",
    "end_of_orders_list": "fim da lista de encomendas",
    "orderDate": "DATA DA ENCOMENDA",
    "orderNumber": "NÚMERO DA ENCOMENDA",
    "subscriptionNumber": "NÚMERO DA SUBSCRIÇÃO",
    "accountName": "CONTA ATRIBUÍDA",
    "unassigned": "Não atribuído",
    "unavailable": "Indisponível",
    "expiring": "EXPIRANDO EM BREVE",
    "assign": "ATRIBUIR",
    "expired": "EXPIRADO",
    "perpetual": "DEFINITO",
    "pending": "ATIVAÇÃO PENDENTE",
    "error_retrieving_orders": "Ocorreu um erro ao recuperar os pedidos.",
    "no_orders_found": "Nenhuns pedidos encontrados.",
    "deploy": "Implantar",
    "activate": "Ativar"
  },
  "order_details": {
    "deploy_button": "Implantar",
    "activate_button": "Ativar",
    "assign_button": "Atribuir",
    "order_number": "N.º da Encomenda",
    "tracking_number": "Número de Rastreio",
    "subscription_number": "N.º da Subscrição",
    "see_additional_details": "Veja detalhes de rastreio adicionais",
    "hide_additional_details": "Feche detalhes de rastreio adicionais",
    "po_number": "Número do pedido do revendedor",
    "reseller_SAP_Id": "Identificação SAP do revendedor",
    "sapOrderId": "ID do pedido SAP",
    "order_assigned_to": "Pedido atribuído a",
    "start_date": "Data de início",
    "term": "Termo",
    "please_pick_acct_msg": "Não foi possível corresponder a este pedido, portanto, selecione manualmente uma conta para a aplicar.",
    "company": "Empresa",
    "create_new_account": "Criar nova conta",
    "order_expiry_time": "A ENCOMENDA IRÁ EXPIRAR DENTRO DE {{numdays}} DIAS",
    "licenses": "Licenças",
    "license": "Licença",
    "customerSapId": "Identificação SAP do cliente",
    "customerPONumber": "Número do pedido do cliente",
    "search_companies": "Procurar empresas",
    "month": "Mês",
    "year": "Ano",
    "day": "Dia",
    "unknown": "Desconhecido",
    "assigning_account_to_order": "A atribuir a encomenda à conta...",
    "deploying_order": "Pedido sendo implantado...",
    "activating_order": "Ativando pedido...",
    "error_assigning_order": "Ocorreu um erro ao atribuir a encomenda à conta.",
    "error_deploying_order": "Ocorreu um erro ao implementar o pedido.",
    "error_activating_order": "Ocorreu um erro ao ativar o pedido.",
    "cannot_comm_parent": "Não podemos redirecioná-lo para o formulário adequado. Pode criar uma conta na aplicação de Contas.",
    "no_results_found": "Não foram encontrados resultados",
    "existing-subscription": "Falha na atribuição: esta empresa já tem um pedido.",
    "0001": "Licenças insuficientes. O número de licenças gratuitas atribuídas ({free}) excede o número de licenças ({paid}) na encomenda paga.",
    "restricted_view_warning": "Funcionalidades desativadas. Seu acesso está restrito."
  },
  "order_complete": {
    "go-to-account-integrations": "Ir a integrações das contas",
    "go-to-account": "Ir para a conta",
    "activate-order": "Ativar pedido",
    "order-added": "Pedido adicionado!",
    "order-deployed": "Pedido implementado!",
    "order-activated": "Pedido ativado!",
    "enable-integration": "Apenas uma nota, os itens neste pedido para funcionarem requerem uma integração para serem configurados e ativados.",
    "activate-order-instructions": "Apenas uma nota: este pedido precisa ser ativado para funcionar."
  },
  "errors": {
    "504-general-message": "A solução está ocupada ou inacessível. Tente novamente.",
    "couldnt-find-order": "Não encontrámos o pedido na lista. Por favor, recarregue a página."
  }
}